import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  IconButton,
  CircularProgress,
  Button,
} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate } from "react-router-dom";
import { getData } from "../../Webservice/Webservice";
import { getIsBusiness } from "../../Utils/authHelper";

const rubikfont = {
  fontFamily: "Rubik, sans-serif",
};

function WishList() {
  const navigate = useNavigate();
  const isBusiness = getIsBusiness();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWishlist = async () => {
      const tokenValue = localStorage.getItem("website_jwt_token");
      const token = tokenValue ? `Bearer ${tokenValue}` : "";

      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await getData("wishlist/list", null, token);
        if (response && response.products) {
          setProducts(response.products);
        }
      } catch (error) {
        console.error("Error fetching wishlist:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchWishlist();
  }, []);

  if (loading) {
    return (
      <Box sx={{ minHeight: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container sx={{ py: { xs: 5, md: 8 }, ...rubikfont }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: { xs: 4, md: 6 },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: "28px", sm: "36px", md: "43.75px" },
            color: "#222",
            letterSpacing: "1.5px",
            fontWeight: 500,
            ...rubikfont,
          }}
        >
          WISHLIST
        </Typography>
      </Box>

      {/* Product Grid */}
      {products.length > 0 ? (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)",
            },
            gap: { xs: 2, sm: 3, md: 4 },
          }}
        >
          {products.map((product, index) => (
            <Box
              onClick={() => navigate(`/product/${product._id}`)}
              key={product._id || index}
              className="product-card"
              sx={{
                bgcolor: "white",
                borderRadius: 2,
                overflow: "hidden",
                transition: "all 0.3s ease",
                cursor: "pointer",
                border: "1px solid #f0f0f0",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                  "& .product-image": {
                    transform: "scale(1.08)",
                  },
                  "& .action-icons": {
                    transform: "translateY(-50%) translateX(0)",
                    opacity: 1,
                  },
                },
              }}
            >
              {/* Product Image */}
              <Box
                sx={{
                  position: "relative",
                  aspectRatio: "1 / 1",
                  width: "100%",
                  overflow: "hidden",
                  bgcolor: "#ffffff", // Use white background like Amazon
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 2, // Padding around the image to make it smaller/framed
                }}
              >
                <img
                  src={product.product_images && product.product_images.length > 0 ? product.product_images[0] : "https://via.placeholder.com/300"}
                  alt={product.title}
                  className="product-image"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain", // Contain fit to avoid cropping
                    transition: "transform 0.4s ease",
                  }}
                />

                {/* Action Icons */}
                <Box
                  className="action-icons"
                  sx={{
                    position: "absolute",
                    right: 10,
                    top: "40%",
                    transform: "translateY(-50%) translateX(60px)",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    opacity: 0,
                    transition: "all 0.4s ease",
                  }}
                >
                  {/* <IconButton
                    sx={{
                      bgcolor: "white",
                      color: "black",
                      width: { xs: 35, sm: 40, md: 45 },
                      height: { xs: 35, sm: 40, md: 45 },
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      "&:hover": {
                        bgcolor: "#222",
                        color: "white",
                        transform: "scale(1.1)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    <FavoriteIcon sx={{ fontSize: { xs: 16, sm: 18, md: 20 }, color: "red" }} />
                  </IconButton> */}

                  {/* <IconButton
                    sx={{
                      bgcolor: "white",
                      width: { xs: 35, sm: 40, md: 45 },
                      height: { xs: 35, sm: 40, md: 45 },
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      "&:hover": {
                        bgcolor: "#222",
                        color: "white",
                        transform: "scale(1.1)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    <ShoppingCartOutlinedIcon
                      sx={{ fontSize: { xs: 16, sm: 18, md: 20 } }}
                    />
                  </IconButton> */}

                  {/* <IconButton
                    onClick={() => navigate(`/product/${product._id}`)}
                    sx={{
                      bgcolor: "white",
                      width: { xs: 35, sm: 40, md: 45 },
                      height: { xs: 35, sm: 40, md: 45 },
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      "&:hover": {
                        bgcolor: "#222",
                        color: "white",
                        transform: "scale(1.1)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    <VisibilityOutlinedIcon
                      sx={{ fontSize: { xs: 16, sm: 18, md: 20 } }}
                    />
                  </IconButton> */}
                </Box>
              </Box>

              {/* Product Details */}
              <Box sx={{ p: { xs: 1, sm: 1.5, md: 2 } }}>
                <Typography
                  sx={{
                    fontSize: { xs: "14px", sm: "16px", md: "18px" },
                    fontWeight: 500,
                    color: "#222",
                    // mb: 1.5,
                    minHeight: { xs: "36px", sm: "44px", md: "48px" },
                    ...rubikfont,
                  }}
                >
                  {product.title}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {/* Selling Price */}
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", sm: "18px", md: "20px" },
                      fontWeight: 500,
                      color: "#222",
                      ...rubikfont,
                    }}
                  >
                    ₹{Number((isBusiness ? (product.b2b_sellingPrice || product.b2c_sellingPrice) : (product.b2c_sellingPrice || product.sellingPrice)) || 0).toFixed(2)}
                  </Typography>
                  {/* MRP */}
                  {(() => {
                    const displayMrp = isBusiness ? (product.b2b_mrp || product.b2c_mrp) : product.b2c_mrp;
                    const displayPrice = isBusiness ? (product.b2b_sellingPrice || product.b2c_sellingPrice) : (product.b2c_sellingPrice || product.sellingPrice);
                    return displayMrp > displayPrice ? (
                      <Typography
                        sx={{
                          fontSize: { xs: "13px", sm: "14px", md: "16px" },
                          color: "red",
                          textDecoration: "line-through",
                          ...rubikfont,
                        }}
                      >
                        ₹{Number(displayMrp || 0).toFixed(2)}
                      </Typography>
                    ) : null;
                  })()}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        // empty state: a fixed-size, centred card with a clear next step
        <Box
          sx={{
            width: "100%",
            maxWidth: 520,
            minHeight: 340,
            mx: "auto",
            my: { xs: 2, md: 4 },
            px: { xs: 3, sm: 5 },
            py: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            borderRadius: "24px",
            border: "1px solid #efe6d0",
            background: "linear-gradient(180deg, #fffdf8 0%, #fbf5e6 100%)",
            boxShadow: "0 8px 28px rgba(60,40,10,0.07)",
          }}
        >
          <Box
            sx={{
              width: 96,
              height: 96,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "#fbe4e4",
              color: "#e57373",
              mb: 2.5,
              boxShadow: "0 0 0 10px rgba(229,115,115,0.12)",
            }}
          >
            <FavoriteBorderIcon sx={{ fontSize: 46 }} />
          </Box>

          <Typography sx={{ fontSize: { xs: "20px", sm: "22px" }, fontWeight: 600, color: "#111", ...rubikfont }}>
            Your wishlist is empty
          </Typography>
          <Typography sx={{ mt: 1, mb: 3, maxWidth: 360, fontSize: "14.5px", lineHeight: 1.6, color: "text.secondary", ...rubikfont }}>
            Tap the heart on any product to save it here, so it is easy to find when you are ready to buy.
          </Typography>

          <Button
            variant="contained"
            disableElevation
            startIcon={<ShoppingBagOutlinedIcon />}
            onClick={() => navigate("/")}
            sx={{ px: 3, py: 1, borderRadius: "12px", textTransform: "none", fontWeight: 600, bgcolor: "#C8A054", "&:hover": { bgcolor: "#b38841" }, ...rubikfont }}
          >
            Explore products
          </Button>
        </Box>
      )}
    </Container>
  );
}

export default WishList;
